import React, { memo, useEffect, useCallback } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { getMinePayList } from '../../../actions/wallpaperPay';
import InfiniteScroll from 'react-infinite-scroller';
import WallpaperMinePay from '../WallpaperMinePay';
import hint from '../../../static/wp_blank.png';
import { logging, logPostInfo } from '../../../actions/log';
import Blank from '../Blank';
import styles from './Paylist.module.less';
import { useActivate } from 'react-activation';

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectMineInfo = createSelector(
  state => {
    return state.wallpaperPay;
  },
  info => {
    return info.minePayInfo;
  },
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ node }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);
  const mineInfo = useSelector(selectMineInfo);
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    if (userInfo && userInfo.st) {
      dispatch(
        getMinePayList({
          ...mineInfo.pagenation,
          tagId: 'paylist',
          skip: 0,
          refresh: true,
        }),
      );
    }
  }, [userInfo]);

  useActivate(() => {
    dispatch(
      getMinePayList({
        ...mineInfo.pagenation,
        tagId: 'paylist',
        skip: 0,
        refresh: true,
      }),
    );
  });

  const loadMore = () => {
    if (!mineInfo.load && mineInfo.pagenation.tagId === 'paylist') {
      const params = {
        ...mineInfo.pagenation,
      };
      delete params.count;
      delete params.tagId;
      // dispatch(
      //   getMinePayList({
      //     ...mineInfo.pagenation,
      //     tagId: 'paylist',
      //     refresh: false,
      //   }),
      // );
    }
  };

  const handleLogin = useCallback(() => {
    window.CallNativeMethod('logout');
    window.CallNativeMethod('login');
    // 点击 登录
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Login',
        label: '',
        param2: {
          source: `Wallpaper_Mine||setup`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [dispatch, logInfoData]);

  return (
    <div>
      {userInfo && userInfo.st && mineInfo.pagenation.count > -1 && (
        <InfiniteScroll
          pageStart={1}
          loadMore={loadMore}
          hasMore={mineInfo.list.length < mineInfo.pagenation.count}
          loader={
            <div className="loader" key={0}>
              --加载中--
            </div>
          }
          initialLoad={!mineInfo.list.length}
          useWindow={false}
          getScrollParent={() => node}
        >
          <WallpaperMinePay mineInfo={mineInfo} logInfo={{ source: `Wallpaper_Mine||paylist` }} />

          {mineInfo.list.length >= mineInfo.pagenation.count && mineInfo.pagenation.count !== 0 && (
            <div className="loader">--到底啦--</div>
          )}
        </InfiniteScroll>
      )}
      {!userInfo ||
        (userInfo && !userInfo.st && (
          <div className={styles.nologin}>
            <div className={styles.blank}>
              <div className={styles.blank_img}>
                <img src={hint} alt="" className={styles.backColor} />
              </div>
              <div className={styles.text}>
                登录后，查看“ 壁纸订单 ” <span onClick={handleLogin}>立即登录</span>
              </div>
            </div>
          </div>
        ))}
      {userInfo && userInfo.st && mineInfo.pagenation.count < 1 && mineInfo.list?.length < 1 && (
        <div className={styles.blank}>
          <Blank load={mineInfo.load} />
        </div>
      )}
    </div>
  );
});
